import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { supportedLanguages } from "../i18n";

/**
 * زرار تبديل اللغة. بيحافظ على نفس الصفحة الحالية، بس بيغيّر بادئة اللغة في الرابط
 * (مثال: من /country/jordan لـ /en/country/jordan)
 */
export default function LanguageSwitcher({ className = "" }) {
  const location = useLocation();
  const navigate = useNavigate();

  const currentLang = (() => {
    const seg = location.pathname.split("/")[1];
    return seg in supportedLanguages ? seg : "ar";
  })();

  const switchTo = (lang) => {
    const parts = location.pathname.split("/").filter(Boolean);
    // نشيل بادئة اللغة الحالية لو موجودة
    if (parts[0] in supportedLanguages) parts.shift();
    const rest = parts.join("/");
    const prefix = lang === "ar" ? "" : `/${lang}`;
    navigate(`${prefix}/${rest}`.replace(/\/+$/, "") || "/");
  };

  return (
    <div className={`flex items-center gap-1 text-sm ${className}`}>
      {Object.entries(supportedLanguages).map(([code, cfg]) => (
        <button
          key={code}
          onClick={() => switchTo(code)}
          className={`px-2 py-1 rounded-md font-bold transition-colors ${
            currentLang === code ? "bg-primary-500 text-white" : "text-gray-500 hover:bg-gray-100"
          }`}
        >
          {code.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
